import { greaterAreaCrudConfig, type GreaterArea } from '@/config/objects/greater-areas';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate } from 'react-router-dom';

const breadcrumbs = [
  { label: 'Home', href: '/' },
  { label: 'Greater Areas', current: true },
];

export function GreaterAreasPage() {
  const navigate = useNavigate();
  return (
    <PageContainer>
      <CrudListView
        config={greaterAreaCrudConfig}
        baseUrl="/greater-areas"
        breadcrumbs={breadcrumbs}
        onItemClick={(item: GreaterArea) => navigate(`/greater-areas/${item.id}/edit`)}
        getValueFromItem={(item: GreaterArea) => item.id}
        getLabelFromItem={(item: GreaterArea) => item.name}
      />
    </PageContainer>
  );
}
